export var CalendarPopoverSides;
(function (CalendarPopoverSides) {
    CalendarPopoverSides["Right"] = "right";
    CalendarPopoverSides["Left"] = "left";
})(CalendarPopoverSides || (CalendarPopoverSides = {}));
export var CalendarPopoverDataKeys;
(function (CalendarPopoverDataKeys) {
    CalendarPopoverDataKeys["WithShadow"] = "data-shadow";
    CalendarPopoverDataKeys["WithArrow"] = "data-arrow";
    CalendarPopoverDataKeys["Title"] = "data-title";
    CalendarPopoverDataKeys["ArrowTop"] = "data-arrow-top";
    CalendarPopoverDataKeys["Animated"] = "data-animated";
    CalendarPopoverDataKeys["Shown"] = "data-shown";
    CalendarPopoverDataKeys["ArrowSide"] = "data-side";
    CalendarPopoverDataKeys["ManualFocus"] = "data-manual-focused";
})(CalendarPopoverDataKeys || (CalendarPopoverDataKeys = {}));
//# sourceMappingURL=types.js.map